import { useContext, useEffect, useState } from "react";
import Button from "react-bootstrap/Button";
import Card from "react-bootstrap/Card";
import Col from "react-bootstrap/Col";
import ListGroup from "react-bootstrap/ListGroup";
import Row from "react-bootstrap/Row";
import { Helmet } from "react-helmet-async";
import { Store } from "../Store";
import {
  getLocalTimeFormatted,
  round2,
  turkishCurrencyFormatterNoPrecision,
} from "../utils";
import MessageBox from "./MessageBox";

export default function CustomerCart(props) {
  const { state, dispatch: ctxDispatch } = useContext(Store);
  const { carts } = state;
  const { tableNum } = props;
  const [cart, setCart] = useState({ cartItems: [] });
  const [passedTime, setPassedTime] = useState();
  const [ozetle, setOzetle] = useState(false);
  const { customerName, table } = props;

  const decrementCartItemHandler = async (item, index) => {
    ctxDispatch({
      type: "CART_DECREMENT_ITEM",
      payload: { ...item, index, tableNum: table, decrementValue: 1 },
    });
  };
  const incrementCartItemHandler = async (item, index) => {
    ctxDispatch({
      type: "CART_INCREMENT_ITEM",
      payload: { ...item, index, tableNum: table, incrementValue: 1 },
    });
  };
  const removeItemHandler = (item, i) => {
    item.index = i;
    ctxDispatch({ type: "CART_REMOVE_ITEM", payload: { item, tableNum } });
  };

  const editHandler = (index) => {
    ctxDispatch({
      type: "CART_ITEM_EDITABLE",
      payload: { index, tableNum },
    });
  };

  useEffect(() => {
    if (tableNum > 0) {
      setCart({
        ...carts[tableNum - 1],
        summaryCartItems: getSummaryCartItems(
          carts[tableNum - 1].cartItems,
          false
        ),
        description: carts[tableNum - 1].description
          ? carts[tableNum - 1].description
          : "",
        totalPrice: round2(
          carts[tableNum - 1].cartItems
            .filter((x) => !x.isGift)
            .reduce(
              (a, c) =>
                a +
                c.quantity * (c.feature ? c.feature.price + c.price : c.price),
              0
            )
        ),
        totalCount: carts[tableNum - 1].cartItems
          .filter((x) => !x.isGift)
          .reduce((a, c) => a + c.quantity, 0),
      });
    }
  }, [tableNum, carts]);

  useEffect(() => {
    if (cart.cartItems.length > 0) {
      let secTimer = setInterval(() => {
        var miliSeconds =
          new Date().getTime() -
          new Date(cart.cartItems[0].createdAt).getTime();

        setPassedTime(new Date(miliSeconds).toISOString().substring(11, 19));
      }, 1000);

      return () => clearInterval(secTimer);
    } else {
      if (cart.cartItems.length > 0 && cart.cartItems[0].approvedAt) {
        var miliSeconds =
          new Date(cart.cartItems[0].approvedAt).getTime() -
          new Date(cart.cartItems[0].createdAt).getTime();
        setPassedTime(new Date(miliSeconds).toISOString().substring(11, 19));
      }
    }
  }, [tableNum, cart]);

  return (
    <div>
      <Helmet>
        <title>Siparişler</title>
      </Helmet>
      <Card>
        <Card.Body>
          <Row>
            {cart.cartItems.length > 3 && (
              <Col xs={4}>
                <Button
                  variant={ozetle ? "primary" : "danger"}
                  onClick={() => setOzetle(!ozetle)}
                >
                  {ozetle ? "Detay" : "Özet"}
                </Button>
              </Col>
            )}
            <Col xs={4}>
              {cart.cartItems.length > 0 && (
                <div>
                  <span className="small-font">{passedTime}</span>
                </div>
              )}
              <div>
                <span>{customerName}</span>
              </div>
            </Col>

            <Col className="col text-end">
              <span className="small-font">
                {cart.cartItems.length > 0
                  ? new Date(cart.cartItems[0].createdAt).toLocaleDateString(
                      "tr-TR"
                    )
                  : ""}
              </span>
            </Col>
          </Row>
        </Card.Body>
      </Card>
      <Row>
        <Col xs={12}>
          {cart.cartItems.length === 0 ? (
            tableNum ? (
              <MessageBox>Sipariş Yok</MessageBox>
            ) : (
              <MessageBox>Lütfen bir masa seçiniz</MessageBox>
            )
          ) : (
            <ListGroup>
              {(ozetle ? cart.summaryCartItems : cart.cartItems).map(
                (item, i) => (
                  <ListGroup.Item key={ozetle ? item.name : item.itemCode}>
                    <Row className="align-items-center">
                      <Col xs={7}>
                        {!item.approvedAt && item.editable && (
                          <Row>
                            <Col>
                              <Button
                                onClick={() =>
                                  decrementCartItemHandler(item, i)
                                }
                                variant="light"
                                disabled={item.quantity === 1}
                              >
                                <i className="fas fa-minus-circle"></i>
                              </Button>{" "}
                              <span>x{item.quantity}</span>{" "}
                              <Button
                                variant="light"
                                onClick={() =>
                                  incrementCartItemHandler(item, i)
                                }
                                disabled={item.quantity === item.countInStock}
                              >
                                <i className="fas fa-plus-circle"></i>
                              </Button>
                            </Col>
                          </Row>
                        )}
                        <Row>
                          <Col>
                            <span style={{ fontWeight: "bold" }}>
                              {ozetle ? item.quantity2 : item.quantity}
                            </span>{" "}
                            {item.feature ? item.feature.name + " " : ""}
                            {item.name} {" - "}
                            {turkishCurrencyFormatterNoPrecision(
                              item.price +
                                (item.feature ? item.feature.price : 0)
                            )}
                          </Col>
                        </Row>
                        {item.answer && (
                          <Row>
                            <Col className="small-font text-danger">
                              {item.answer}!
                            </Col>
                          </Row>
                        )}
                      </Col>

                      <Col xs={2}>
                        <span>
                          {turkishCurrencyFormatterNoPrecision(
                            ((item.feature ? item.feature.price : 0) +
                              item.price) *
                              item.quantity
                          )}
                        </span>
                      </Col>
                      <Col xs={3}>
                        {!item.approvedAt && item.editable && (
                          <Row>
                            <Col>
                              <Button
                                onClick={() => removeItemHandler(item, i)}
                                variant="light"
                              >
                                <i className="fas fa-trash"></i>
                              </Button>
                            </Col>
                          </Row>
                        )}

                        <Row>
                          <Col xs={7}>
                            <div
                              className={
                                item.approvedAt
                                  ? "small-font text-success"
                                  : "small-font text-danger"
                              }
                            >
                              {getLocalTimeFormatted(item.createdAt)}{" "}
                            </div>
                          </Col>
                          {!item.approvedAt && !ozetle && (
                            <Col xs={5}>
                              {item.tableCode ? (
                                <i className="fas fa-check text-success"></i>
                              ) : (
                                <Button
                                  variant="light zeropadding"
                                  onClick={() => editHandler(i)}
                                >
                                  <h5>
                                    <i className="fas fa-edit"></i>
                                  </h5>
                                </Button>
                              )}
                            </Col>
                          )}
                        </Row>
                      </Col>
                    </Row>
                  </ListGroup.Item>
                )
              )}
            </ListGroup>
          )}
        </Col>
      </Row>
      <Card>
        <Card.Body>
          <Row className="mb-3">
            <Col xs={7}>
              <h4>Toplam ({cart.totalCount} Adet)</h4>
            </Col>
            <Col xs={5}>
              <h4>
                <span className={cart.isStfMeal ? "isGift text-danger" : ""}>
                  {turkishCurrencyFormatterNoPrecision(cart.totalPrice)}
                </span>
              </h4>
            </Col>
          </Row>
        </Card.Body>
      </Card>
    </div>
  );
}

function getSummaryCartItems(cartItems, historic) {
  let summaryCartItems = [];
  cartItems.forEach((item) => {
    const filteredItem = historic
      ? summaryCartItems.filter((v) => v.product === item.product)
      : summaryCartItems.filter((v) => v._id === item._id);

    if (filteredItem && filteredItem.length > 0) {
      filteredItem[0].quantity2 = filteredItem[0].quantity2 + item.quantity;
      filteredItem[0].price =
        filteredItem[0].price +
        ((item.feature ? item.feature.price : 0) + item.price) * item.quantity;
    } else {
      summaryCartItems = [
        ...summaryCartItems,
        {
          ...item,
          price:
            ((item.feature ? item.feature.price : 0) + item.price) *
            item.quantity,
          editable: false,
          quantity: 1,
          feature: "",
          quantity2: item.quantity,
        },
      ];
    }
  });
  return summaryCartItems;
}
